// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonsArrowsFilter_wrap__PvUOq"};